/**
 * The property panel puts focus in the section the reader just opened, so they can type straight
 * away. It used to find that control by antd's class names, and each one went dead the moment its
 * control moved to the kit — the section's own collapse first, which silenced the whole thing.
 *
 * These are the controls by what they ARE rather than whose they are: a text field, a textarea, a
 * select's search box (an input like any other, whatever draws it), a checkbox and a switch. antd
 * and the kit render all of them the same way at this level, so the lookup survives either.
 */
const EDITABLE_CONTROL: string = [
  'input:not([type="hidden"]):not([disabled])',
  "textarea:not([disabled])",
  '[role="switch"]:not([disabled])'
].join(", ");

/**
 * The property section the reader has open. The panel's sections are the kit's collapse, which is
 * rc-collapse underneath — the name this used to look for was antd's, and it matched nothing once
 * the sections moved, which is why focus stopped following the reader into them.
 */
export const EXPANDED_PROPERTY_SECTION: string = ".kuika_propertyFormComp .rc-collapse-content-active";

/** The first control in `section` a reader can edit, in the order they would reach it. */
export const findFirstEditableControl = (section: Element | null): HTMLElement | null => {
  if (!section) return null;
  return section.querySelector<HTMLElement>(EDITABLE_CONTROL);
};

/** Moves focus to the first editable control in `section`, when there is one. */
export const focusFirstEditableControl = (section: Element | null): void => {
  findFirstEditableControl(section)?.focus();
};
